'use strict';

module.exports = function($stateProvider) {

    $stateProvider
        .state('dashboard.departments.department.teams', {
            url: '/teams',
            templateUrl: 'dashboard-teams/dashboard-teams.html',
            controller: 'dashboardTeamsCtrl as ctrl',
            resolve: {
                teams: ['Department', '$stateParams', function(Department, $stateParams) {
                    return Department
                        .teams({
                            filter: {
                                include: 'members'
                            },
                            id: $stateParams.departmentId
                        })
                        .$promise
                        .then(function(teams) {
                            return teams;
                        });
                }]
            },
            data: {
                authorizedRoles: ['admin', 'owner','supervisor','fieldAdmin']
            }
        });
};
